import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    devices: []
  },
  getters: {},
  mutations: {},
  actions: {

    async getAll(_, params) {
      try {
        const response = await axios.get(`v1/ai-analytics/servers/devices`, {
            params
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching AI analytics servers: ", error);
        return [];
      }
    },

    async add(_, params) {
      try {
        const { data } = await axios.post("v1/ai-analytics/servers/devices", params);
        return data;
      } catch (error) {
        console.error("Error adding AI analytics server device: ", error);
        return null;
      }
    },

    async delete(_, params) {
      try {
        const { data } = await axios.delete(`v1/ai-analytics/servers/devices`, { data: params });
        return data;
      } catch (error) {
        console.error(`Error deleting AI analytics server device: `, error);
        return null;
      }
    },

    async updateStatus(_, params) {
      try {
        const { data } = await axios.post("v1/ai-analytics/servers/update-device-status", params);
        return data;
      } catch (error) {
        console.error("Error updating AI analytics server device status: ", error);
        return null;
      }
    },

    async restartServer(_, uuid) {
      try {
        const { data } = await axios.post(`v1/ai-analytics/restart-server/${uuid}`);
        return data;
      } catch (error) {
        console.error("Error restarting AI analytics server: ", error);
        return null;
      }
    },
  }
};
